var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTicketLoading = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3141_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.383 127.06H99.0493V40.7852H139.43C142.859 40.7852 145.526 43.1381 146.668 46.2754L160.002 87.844V119.217C160.002 123.53 156.573 127.06 152.383 127.06Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 126.667H7.69231C3.46154 126.667 0 123.564 0 119.77V33.5635C0 29.7704 3.46154 26.667 7.69231 26.667H92.3077C96.5385 26.667 100 29.7704 100 33.5635V126.667Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.523 146.667C140.042 146.667 148.57 137.888 148.57 127.059C148.57 116.23 140.042 107.451 129.523 107.451C119.003 107.451 110.475 116.23 110.475 127.059C110.475 137.888 119.003 146.667 129.523 146.667Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0969 146.667C48.6166 146.667 57.1446 137.888 57.1446 127.059C57.1446 116.23 48.6166 107.451 38.0969 107.451C27.5772 107.451 19.0493 116.23 19.0493 127.059C19.0493 137.888 27.5772 146.667 38.0969 146.667Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.525 134.903C133.733 134.903 137.144 131.392 137.144 127.06C137.144 122.728 133.733 119.217 129.525 119.217C125.317 119.217 121.906 122.728 121.906 127.06C121.906 131.392 125.317 134.903 129.525 134.903Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0941 134.903C42.302 134.903 45.7132 131.392 45.7132 127.06C45.7132 122.728 42.302 119.217 38.0941 119.217C33.8863 119.217 30.4751 122.728 30.4751 127.06C30.4751 131.392 33.8863 134.903 38.0941 134.903Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.763 83.9221H118.097C115.811 83.9221 114.287 82.3535 114.287 80.0005V52.5495C114.287 50.1966 115.811 48.6279 118.097 48.6279H138.287C139.811 48.6279 141.335 49.8044 141.716 51.373L148.192 71.7652C148.192 72.1574 148.573 72.5495 148.573 72.9417V80.0005C148.573 82.3535 147.049 83.9221 144.763 83.9221Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0003 82.2225C32.3336 82.2225 29.3336 79.2225 29.3336 75.5559V64.4448C29.3336 60.7781 32.3336 57.7781 36.0003 57.7781V53.3337C29.8892 53.3337 24.8892 58.3337 24.8892 64.4448V75.5559C24.8892 81.667 29.8892 86.667 36.0003 86.667H48.4447V82.2225H36.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.001 91.5566L55.3343 84.4455L46.001 77.3344V91.5566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4442 57.7781C64.1108 57.7781 67.1108 60.7781 67.1108 64.4448V75.5559C67.1108 79.2225 64.1108 82.2225 60.4442 82.2225V86.667C66.5553 86.667 71.5553 81.667 71.5553 75.5559V64.4448C71.5553 58.3337 66.5553 53.3337 60.4442 53.3337H47.1108V57.7781H60.4442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4447 62.668L41.1113 55.5569L50.4447 48.4458V62.668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3141_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTicketLoading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TicketLoading.701099b6.svg";
export { ForwardRef as ReactComponent };